<template>
  <div id="register" class="mdl-grid">
    <div class="mdl-layout-spacer"></div>
    <div class="mdl-cell mdl-cell--4-col">
       <form v-on:submit.prevent="attemptRegister">
        <div class="mdl-card mdl-shadow--6dp">
          <div class="mdl-card__title mdl-color--primary mdl-color-text--white">
            <h2 class="mdl-card__title-text">Create Account</h2>
          </div>
          <div class="mdl-card__supporting-text">
              <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label" v-mdl>
                <input class="mdl-textfield__input" type="text" id="username" v-model="user"/>
                <label class="mdl-textfield__label" for="username">Email</label>
              </div>
              <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label" v-mdl>
                <input class="mdl-textfield__input" type="password" id="userpass" v-model="password"/>
                <label class="mdl-textfield__label" for="userpass">Password</label>
              </div>
          </div>
          <div class="mdl-card__actions mdl-card--border">
            <button class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect" type="submit" v-mdl>Sign up</button>
          </div>
        </div>
      </form>
    </div>
    <div class="mdl-layout-spacer"></div>
  </div>
</template>

<script>
export default {
  name: 'Register',
  data: function () {
    return {
      user: '',
      password: ''
    }
  },
  methods: {
    attemptRegister: async function () {
      try {
        await this.$store.dispatch('signup', {
          user: this.user,
          password: this.password
        })
        this.$router.push('verifyaccount')
      } catch (e) {
        alert('Could not register user! ' + JSON.stringify(e))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.create-account-wrapper {
  padding: 50px 0;
}
.mdl-layout {
  align-items: center;
  justify-content: center;
}
.mdl-layout__content {
  padding: 24px;
  flex: none;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Register.vue